import { proto as AsrProto } from '../../proto/AsrProto';
import type { KeyPhraseIntegrationWords, RootState, TrainerAsrConfigErrors, TrainerSpottingScore } from '../types';

export const getTrainer = (store: RootState) => store.trainer;

export const getUserInterfaceConfig = (store: RootState) => store.trainer.userInterfaceConfig;

export const hasTrainerError = (store: RootState) => store.trainer.errorCode != null;
export const isTranscriptVisible = (store: RootState) => store.trainer.showTranscript;
export const getElapsedSeconds = (store: RootState) => store.trainer.elapsedSeconds;
export const getSuggestionCallFrequency = (store: RootState) => store.trainer.suggestionCallFrequency;
export const getWhitelistPhrasesSpottingScore = (store: RootState): TrainerSpottingScore | null =>
    store.trainer.whitelistPhrasesSpottingScore;
export const getLastCallPhraseSpottingScore = (store: RootState): TrainerSpottingScore | null => store.trainer.lastCallPhraseSpottingScore;
export const isTrainerActive = (store: RootState) => Boolean(store.trainer.isTrainerActive);
export const isTrainerStatusUpdating = (store: RootState) =>
    Boolean((store.trainer as RootState['trainer'] & { isSettingSnoozeTimer?: boolean }).isSettingSnoozeTimer);
export const canDisplaySnoozingControls = (store: RootState) => Boolean(store.trainer.userInterfaceConfig.displaySnoozingControls);
export const canDisplayOnlineButton = (store: RootState) => Boolean(store.trainer.userInterfaceConfig.displayOnlineButton);
export const canDisplayCallOptOutControls = (store: RootState) => Boolean(store.trainer.userInterfaceConfig.displayCallOptOutControls);
export const canShowDashboardLink = (store: RootState) => Boolean(store.trainer.userInterfaceConfig.showDashboardLink);
export const isTrainerCallStarted = (store: RootState) => Boolean(store.trainer.isStarted);
export const shouldRecordCall = (store: RootState) => Boolean(store.trainer.recordCall);
export const isCallSimulatorEnabled = (store: RootState) => Boolean(store.trainer.enableCallSimulator);
export const isTrainerEnabled = (store: RootState) => Boolean(store.trainer.enableTrainer);
export const isSalesEnabled = (store: RootState) => Boolean(store.trainer.enableSales);
export const isOptInOn = (store: RootState) => Boolean(store.trainer.optInOn);
export const isOptOut = (store: RootState) => Boolean(store.trainer.isOptOut);

export const isExplicitMode = (store: RootState) =>
    (store.trainer.userInterfaceConfig.integrationMethod || 0) === AsrProto.IntegrationMethod.EXPLICIT;

export const displayTelephonyId = (store: RootState) => Boolean(store.trainer.userInterfaceConfig.displayTelephonyId);
export const hidePersonalUsername = (store: RootState) => Boolean(store.trainer.userInterfaceConfig.hidePersonalUsername);

export const getCallEventNotification = (store: RootState) => store.trainer.callEventNotification;
export const getTrainerAsrConfigErrors = (store: RootState): TrainerAsrConfigErrors => store.trainer.asrConfigErrors || {};
export const getKeyPhraseIntegrationWords = (store: RootState): KeyPhraseIntegrationWords | null => store.trainer.keyPhraseIntegrationWords;

export const isConversionModalOpen = (store: RootState) => Boolean(store.trainer.conversionModalOpen);
